import axios from "axios";

const BASE = "/admin/contracts/companies";

export const listAdminPlatformContracts = (params = {}) => axios.get(BASE, { params });
export const getAdminPlatformContract = (companyId) => axios.get(`${BASE}/${companyId}`);
export const updateAdminPlatformContract = (companyId, payload) =>
  axios.put(`${BASE}/${companyId}`, payload);

// The human lock of the deletion gate (`REG-064`). Confirmation is the company's
// own name, not a generic keyword: in a list of tenants, a keyword would be just
// as easy to type on the wrong row.
export const approveCompanyDeletion = (companyId, confirmationName) =>
  axios.post(`${BASE}/${companyId}/deletion-approval`, { confirmation_name: confirmationName });

export const revokeCompanyDeletionApproval = (companyId) =>
  axios.delete(`${BASE}/${companyId}/deletion-approval`);

export const setCompanyDeletionProtection = (companyId, isProtected) =>
  axios.put(`${BASE}/${companyId}/deletion-protection`, { protected: isProtected });

// Manual deletion: the dry-run first, so nobody confirms without seeing what
// disappears. It changes nothing — the backend rolls its own transaction back.
export const previewCompanyDeletion = (companyId) =>
  axios.get(`${BASE}/${companyId}/deletion-preview`);

export const deleteCompanyPermanently = (companyId, confirmationName) =>
  axios.delete(`${BASE}/${companyId}`, { data: { confirmation_name: confirmationName } });

// `<input type="date">` speaks `YYYY-MM-DD`. The API returns either an ISO
// timestamp or an already formatted date string, so the leading date part is the
// one value both the display and the editor agree on.
export const toAdminContractDateInput = (value) => {
  if (!value) return "";
  const match = String(value).match(/^(\d{4}-\d{2}-\d{2})/);
  if (match) return match[1];
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "" : date.toISOString().slice(0, 10);
};

export const formatAdminContractDate = (value) => {
  if (!value) return "—";
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (match) return `${match[3]}.${match[2]}.${match[1]}`;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return [
    String(date.getDate()).padStart(2, "0"),
    String(date.getMonth() + 1).padStart(2, "0"),
    date.getFullYear(),
  ].join(".");
};
